import { Injectable, InjectionToken, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ConsumerType, CONSUMER_TYPE } from '../../../../domain/consumer-type.domain';
import { WINDOW_TOKEN } from '../../../../services/window.token';
import { LinkRegistryService } from '../../../../services/link-registry.service';
import { ConfigurationService } from '../../../../services/configuration/configuration.service';

import { SecurityOptionsRestService } from './security-options-rest.service';
import {
  TransferInResponse, TransferUapmResponse
} from './security-options.domain';

export const SECURITY_OPTIONS_CONFIGURATION = new InjectionToken<string>('manageSecurityOptionsUrl');

@Injectable({
  providedIn: 'root'
})
export class SecurityOptionsService {
  protected readonly browserWindow = inject<Window>(WINDOW_TOKEN);
  private readonly manageSecurityOptionsUrl = inject(SECURITY_OPTIONS_CONFIGURATION);
  private readonly linkRegistryService = inject(LinkRegistryService);
  private readonly consumerType = inject<ConsumerType>(CONSUMER_TYPE);
  private readonly securityOptionsRestService = inject(SecurityOptionsRestService);
  private readonly configurationService = inject(ConfigurationService);

  goToMSO(): void {
    const params: Record<string, unknown> = {
      channelID: this.consumerType.consumerId,
      returnURL: this.browserWindow.location.href,
      goto: 'UAP_MSO',
      ssoType: 'legacy'
    };

    const msoLink = this.linkRegistryService.addParameters(this.manageSecurityOptionsUrl, params);
    if (msoLink !== undefined) {
      this.browserWindow.location.href = msoLink;
    }
  }

  transferUapm(): Observable<TransferUapmResponse> {
    return this.securityOptionsRestService.transferUapm(this.browserWindow.location.hash);
  }

  transferEasyApply(): Observable<TransferInResponse> {
    return this.securityOptionsRestService.transferEasyApply();
  }

  isSsoWithOauthEnabled(): boolean {
    return this.configurationService.getProperty('enableSsoWithOauth');
  }
}

